import {
  Button,
  CloseButton,
  Flex,
  Heading,
  Modal,
  Spinner,
  TextInput,
} from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";

const ProgramTypesModal = ({ open, setOpen, programType, handleSubmit }) => {
  const [typeName, setTypeName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (programType) {
      setTypeName(programType.name);
    }
  }, [programType]);

  const handleClose = () => {
    setTypeName(programType?.name || "");
    setSubmitting(false);
  };

  const handleSubmitType = async () => {
    setSubmitting(true);
    await handleSubmit(typeName);
    setSubmitting(false);
  };

  return (
    <Modal
      open={open}
      onExited={handleClose}
      label={
        programType
          ? t("programType.editProgramType")
          : t("programType.addProgramType")
      }
      size="medium"
    >
      <Modal.Header>
        <Flex justifyItems="space-between">
          <Flex.Item>
            <Heading level="h2" as="h1">
              {programType
                ? t("programType.editProgramType")
                : t("programType.addProgramType")}
            </Heading>
          </Flex.Item>
          <Flex.Item>
            <CloseButton
              size="small"
              screenReaderLabel={t("global.close")}
              onClick={() => setOpen(false)}
            />
          </Flex.Item>
        </Flex>
      </Modal.Header>
      <Modal.Body>
        <TextInput
          renderLabel={t("programType.programType")}
          value={typeName}
          onChange={(e) => setTypeName(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setOpen(false)} margin="0 small 0 0">
          {t("global.cancel")}
        </Button>
        <Button
          color="primary"
          type="submit"
          onClick={handleSubmitType}
          disabled={!typeName || submitting}
        >
          {submitting ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            t("global.submit")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProgramTypesModal;
